import { KYMW2400Model } from '../kymw2400.model';
import { PageTemplateIDModel } from '../vo/page-template-id.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';

/**
	 * ページテンプレート情報取得コマンド。
	 * クライアントの画面でページテンプレートイメージを表示するための必要情報を取得。
 *
 * @export
 * @class GetPageTemplateInfoService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class GetPageTemplateInfoService extends PlessJsonResponderSub<any> {

  private model: KYMW2400Model = null;
  private vo: PageTemplateIDModel = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetPageTemplateInfoService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        PageTemplateID: this.vo.pageTemplateID
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW2400Model} model モデルクラス
   * @param {number} pageTemplateIndex ページテンプレートIndex
   * @memberof GetPageTemplateInfoService
   */
  execute(model: KYMW2400Model, pageTemplateIndex: number) {
    this.model = model;
    this.model.changePageTemplateID(pageTemplateIndex);
    this.vo = this.model.createPageTemplateIDVO();
    this.send('getPageTemplateInfoByPageTemplate', this.getBody());
    this.model.clearPageTemplateData();
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetPageTemplateInfoService
   */
  success(data: any) {
    this.model.updatePageTemplateData(data);
  }
}
